var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6085 12.9371C26.3895 12.1232 25.7478 11.4816 24.934 11.2624C23.4471 10.8555 17.4998 10.8555 17.4998 10.8555C17.4998 10.8555 11.5526 10.8555 10.0658 11.2469C9.26766 11.4659 8.61027 12.1233 8.39124 12.9371C8 14.4238 8 17.5071 8 17.5071C8 17.5071 8 20.6058 8.39124 22.077C8.61042 22.8908 9.252 23.5325 10.0659 23.7517C11.5683 24.1586 17.5 24.1586 17.5 24.1586C17.5 24.1586 23.4471 24.1586 24.934 23.7672C25.7479 23.5482 26.3895 22.9065 26.6087 22.0927C26.9999 20.6058 26.9999 17.5227 26.9999 17.5227C26.9999 17.5227 27.0156 14.4238 26.6085 12.9371Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.606 20.3555L20.5515 17.507L15.606 14.6586V20.3555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtWhite);
export default __webpack_public_path__ + "static/media/yt-white.664fb1cf3f0fddcc9cf916c5c0711b12.svg";
export { ForwardRef as ReactComponent };